import styled from 'styled-components';

export const Container = styled.header`
  width: 100%;
`;

export const Menu = styled.section`
  height: auto;
  background: #3FB4A8;
  padding: 50px 160px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  nav {
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      height: 90px;
      padding: 0;
    }

    p {
      color: #fff;
      font-size: 20px;
      font-family: Poppins;
      padding: 0;
    }

    div{
      p {
      color: #054F53;
      font-size: 15px;
      font-family: Poppins;
      padding: 0;
    }
    }
  }

  aside {
    display: flex;
    align-items: left;
    display: flex;
    flex-direction: column;
    margin: 0 250px 0 0;

    a {
      font-size: 20px;
      font-family: Poppins;
      font-weight: regular;
      color: #fff;
      padding: 0 31px;
    }

    img {
      height: 100px;
      padding: 0;
    }

    span {
      font-size: 30px;
      font-family: Poppins;
      font-weight: bold;
      color: #fff;
      padding: 0 31px;
    }

    button {
      background: #fff;
      margin-left: 5px;
      padding: 5px;
      border-radius: 15px;

      a {
        font-size: 20px;
        font-family: Poppins;
        font-weight: regular;
        color: #fff;
        padding: 0 31px;
      }
    }
  }
`;

export const ContentBar = styled.section`
  height: 36px;
  padding: 0 250px 0 240px;
  background: #e65c0e;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  nav {
    display: flex;
    align-items: center;

    a {
      padding: 5px;
    }
  }

  aside {
    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      font-weight: bold;
      color: #fff;
    }
  }
`;